import { type LoaderFunctionArgs, redirect } from "react-router";
import { jwtDecode } from "jwt-decode";
import type { RefreshTokenClaims } from "src/utils/auth/auth-schema";
import { authService } from "src/utils/auth/auth-service";
import { consumeSsoRedirectPath } from "src/utils/auth/sso-redirect";

export type TokenRouterLoaderResult = null | {
  error?: string;
};

export const tokenRouterLoader = async (
  args: LoaderFunctionArgs
): Promise<TokenRouterLoaderResult | Response> => {
  const urlToken = args.params.token;

  if (!urlToken) {
    return null;
  }

  const tokenClaims = jwtDecode(urlToken) as RefreshTokenClaims;

  if (tokenClaims.exp && tokenClaims.exp * 1000 < Date.now()) {
    return { error: "Token expired" };
  }

  try {
    const d = await authService.validateToken(urlToken);
    authService.storeSession(d);
    const ssoRedirect = consumeSsoRedirectPath();
    return redirect(ssoRedirect ? `/${ssoRedirect}` : "/");
  } catch (error) {
    return {
      error: error instanceof Error ? error.message : "Token login failed",
    };
  }
};
